module.exports = __webpack_public_path__ + "img/voltage-indicator.3d8299a4.svg";